import React, { useState, useEffect } from "react";
import NewHeader from "../NavBar/newHeader";
import { useNavigate } from "react-router-dom";
import styles from './paymentQr.module.css'
import scanPay from '../../public/assets/scanPayment.png'
import { Button } from "react-bootstrap";
import rightArrow from "../../public/assets/rightArrow.svg";
import QRCode from "react-qr-code";

const QrCodeStatic = () => {
    const[paymentCheck,setPaymentCheck] = useState(false);

    useEffect(() => {
        const nextStep = sessionStorage.getItem('nextStep');
        if(nextStep !== "payment"){
            history('/transaction-detail')
        }
    }, []);

    const history = useNavigate();

    const SaveExit = () => {
        history("/login");
    };

    const redirectToHomePage = () => {
        history('/transaction-detail')
    }

    const transactionValue = sessionStorage.getItem('AmountConversion');
   
    return(
        <>
            <NewHeader onClickLink={SaveExit} show={true}/>
                <div className={`container ${styles.mainContainer}`}>
                    <p className={styles.scanPay}>Scan and Pay</p>
                    <div className={styles.paymentQrCode}>
                        {/* <img src={scanPay} className={styles.imageScan}/> */}
                        <div style={{ background: 'white', padding: '16px' }}>
                        <QRCode
                            size={256}
                            style={{ height: "auto", maxWidth: "30%", width: "30%" }}
                            value={`upi://pay?pa=remitx@icici&pn=RemitX&tn=cftrhwetaw4gta&am=${parseFloat(transactionValue)}`}
                            viewBox={`0 0 256 256`}
                        />
                        </div>
                        <p className={styles.AmountScan}>Amount: ₹{transactionValue}</p>
                    </div>
                    <div className={styles.checkMarkButton}>
                        <div class="form-check" className={styles.checkMark}>
                            <input
                            class="form-check-input"
                            className={styles.checkbox}
                            type="checkbox"
                            id="flexCheckDefault"
                            checked={paymentCheck}
                            onChange={() => {
                                setPaymentCheck(!paymentCheck);
                            }}
                            />
                            <label
                            class="form-check-label"
                            className={styles.checklabel}
                            for="flexCheckDefault"
                            disabled={!paymentCheck}
                            >
                            I confirm that I have made the payment.
                            </label>
                        </div>
                        <Button 
                        className={!paymentCheck ? styles.diabledConfirmPayment : styles.confirmPayment}
                        onClick={paymentCheck ? () => redirectToHomePage() : undefined}
                        >
                            Payment Completed
                            <img className={styles.rightArrow} src={rightArrow} alt="" />
                        </Button>
                    </div>
                </div>
        </>
    )
}

export default QrCodeStatic